import { GetStaticProps } from 'next';

import { PrismicAllBlogPostsQueryDocument } from '@prismic/gqlTypes/prismicHooks';
import {
  PrismicAllBlogPostsQuery,
  PrismicAllBlogPostsQueryVariables,
} from '@prismic/gqlTypes/prismicOperations';

import { incrementalStaticRegenerationRevalidate } from '@temp/constants';
import { prismicApolloClient } from '@utils/ssg';
import { localeToPrismicQuery } from '@utils/regions';

import { generatePrismicSeo } from '@utils/seo';
import { paths } from '@temp/paths';

import { BlogIndexPage, BlogIndexPageProps } from '@temp/views/BlogIndexPage';

export default BlogIndexPage;

export const getStaticProps: GetStaticProps<BlogIndexPageProps> = async ({
  locale,
  defaultLocale,
}) => {
  const { data } = await prismicApolloClient.query<
    PrismicAllBlogPostsQuery,
    PrismicAllBlogPostsQueryVariables
  >({
    query: PrismicAllBlogPostsQueryDocument,
    variables: {
      ...localeToPrismicQuery(locale),
    },
  });

  const seo = await generatePrismicSeo(
    {},
    paths.blog,
    'website',
    locale,
    defaultLocale
  );

  return {
    revalidate: incrementalStaticRegenerationRevalidate,
    props: {
      data,
      seo,
    },
  };
};
